import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import SelectGroupProject from '@/views/App/components/selectGroupProject/selectGroupProject.vue'

@Component({
    inheritAttrs: false,
    components: { SelectGroupProject },
})
export default class Breadcrumbs extends Mixins<MixinInterface>() {
    items: Array<any> = []

    @Watch('$route', { immediate: true, deep: true })
    async onTabChange() {
        this.items = []
        this.$route.matched.map((path) => {
            path.name && path.meta.breadcrumbs !== false
                ? this.items.push({
                      text: path.name,
                      to: { name: path.name },
                      exact: true,
                  })
                : null
        })
    }

    getName(data: any) {
        let name: any = ''
        switch (data) {
            case 'project':
                switch (this.$route.params.type) {
                    case 'p':
                        name = this.$store.getters.project(this.$route.params.id).attributes.name
                        break
                    case 'g':
                        name = this.$store.getters.group(this.$route.params.id).attributes.name
                        break
                }
                break
            case 'user':
                name = this.getFullName(this.$store.getters.user)
                break
            case 'dashboardId':
                name = this.dashboardName
                break
            case 'observation':
                name = this.observationName
                break
            case 'string-group':
                name = this.stringGroupName
                break
            case 'completions':
                name = this.$t(`navigation.psis`)
                break
            case 'personnel':
            case 'contractors':
                name = this.$t(`project_menu.${data}`)
                break
            case 'location-drawing-settings':
                name = this.$t(`project_settings_menu['project.locationDrawing']`)
                break
            case 'settings-course':
                name = this.$t(`project_menu.course`)
                break
            case 'settings-access':
                name = this.$t('project_menu.access_control')
                break
            case 'access-settings-readers':
                name = this.$t('project_settings_menu.readers')
                break
            case 'access-settings-rules':
                name = this.$t('project_settings_menu.rules')
                break
            case 'access-settings-groups':
                name = this.$t('project_settings_menu.groups')
                break
            default:
                name = this.getComplexTranslations(`navigation.${data}`)
        }

        return name
    }

    get dashboardName() {
        return this.$route.params.dashboardId
            ? this.$store.getters.dashboard(this.$route.params.dashboardId).name
            : null
    }

    get observationName() {
        return null
        // this.$route.params.observationId
        //     ? this.$t('navigation.observation', {
        //           observationID: this.$store.getters.observation(this.$route.params.observationId)
        //               .projectObservationId,
        //       })
        //     : null
    }

    get stringGroupName() {
        return ''
        // this.$route.params.stringGroupId
        //     ? this.$store.getters.stringGroup(this.$route.params.stringGroupId).name
        //     : null
    }
}
